import React, { Component } from 'react';
import { Button, Row, Col, Modal, Input } from 'reactstrap';
import { data_change_status, status_change_action, formatDate, funLogout } from "./globalFunction/response_action";
import './TotalCss.css'
import './FetchData.css';
import { api_url } from './globalFunction/global_string';
import DataTable from 'react-data-table-component'; // 引入 DataTable 組件
import { Link } from 'react-router-dom';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export class FetchDataStatistical extends Component {
  static displayName = FetchDataStatistical.name;

  constructor(props) {
    super(props);
    this.state = {
      fetchedData: props.fetchedData,
      apiUrl: props.fetchedData.apiUrl,
      current_user_type: props.fetchedData.current_user_type,
      local_net_id: props.fetchedData.local_net_id,
      local_unit_id: props.fetchedData.local_unit_id,
      url_addr: props.fetchedData.url_addr,
      startDate: props.fetchedData.startDate,
      endDate: props.fetchedData.endDate,
      betaversion: props.fetchedData.betaversion,
      forecasts: [],
      originalForecasts: [],
      filterText: '',
      tableLoading: true,
      fileLoading: false,
      sortColumn: null,
      historyData: [], // 存儲歷史數據
      allForecasts: [],
      showHistoryModal: false,
      urlMap: new Map(),
      columnSort: { url_addr: 'asc', unit_name: 'asc', important: 'asc', building_time: 'asc', lastest_sacn_time: 'asc', lastest_sacn_state: 'asc', danger_high: 'asc', danger_medium: 'asc', danger_low: 'asc', danger_message: 'asc' }
    };
  }
  componentDidMount() {
    const selectedUnit = this.state.fetchedData.selectedUnit;
    const local_unit_name = this.state.fetchedData.local_unit_name;
    this.setState({ selectedUnit, local_unit_name }, () => {
      this.populateWeatherData();
    });
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.fetchedData !== prevProps.fetchedData ||
      this.props.selectnet !== prevProps.selectnet ||
      this.props.selectedUnitproxy !== prevProps.selectedUnitproxy ||
      this.props.local_net_name !== prevProps.local_net_name ||
      this.props.betaversion !== prevProps.betaversion
    ) {
      this.populateWeatherData();
    }
  }

  handleFilterChange = (e) => {
    const originalForecasts = this.state.originalForecasts || this.state.forecasts; // 保存原始數據
    const filterText = e.target.value;

    let updatedForecasts;
    if (filterText) {
      updatedForecasts = originalForecasts.filter((item) => {
        const formatSerialNumber = (row) => {
          const originalFormat = row.build_date;
          const newFormat = originalFormat.replace(/\//g, "").replace(/:/g, "").replace(/ /g, "");
          return `${newFormat}-${row.local_net_id}-${row.local_unit_id}-${row.serial_no}`;
        };

        const searchString = `${formatSerialNumber(item)} ${item.local_unit_name} ${item.url_name} ${item.url_addr}  ${item.build_id} ${item.build_date}`.toLowerCase();
        return searchString.includes(filterText.toLowerCase());
      });
    } else {
      updatedForecasts = originalForecasts;
    }

    this.setState({ filterText, forecasts: updatedForecasts });
  };


  loadData() {
    let apiUrl = api_url + "/api/JRCC/GetLocalUnitId";
    const formData = new FormData();
    formData.append("current_user_type", localStorage.getItem('login_user_type'));
    formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
    formData.append("local_unit_id", localStorage.getItem('login_user_unit_id'));

    fetch(apiUrl, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        if (data.row && Array.isArray(data.row) && data.row.length > 0) {
          this.setState({
            firstLocalUnitName: data.row[0].local_unit_name,
            firstLocalUnitValue: data.row[0].local_unit_id
          });
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }


  render() {
    const { totalSites, highRiskSites, mediumRiskSites, lowRiskSites, messageRiskSites, heavyRiskSites } = this.state;
    const RiskHeader = ({ title, color }) => {
      return (
        <div style={{
          display: 'inline-block',
          backgroundColor: color,
          padding: '10px',
          borderRadius: '0px',
          color: 'white',
          margin: '0px'
        }}>
          {title}
        </div>
      );
    };
    const columns = [
      {
        name: '流水號',
        cell: row => {
          const originalFormat = row.build_date;
          const newFormat = originalFormat.replace(/\//g, "").replace(/:/g, "").replace(/ /g, "");
          return (
            <div className="Research-wrap">
              {`${newFormat}-${row.local_net_id}-${row.local_unit_id}-${row.serial_no}`}
            </div>
          );
        },
        sortable: true,
      },
      {
        name: '單位',
        selector: row => row.local_unit_name,
        cell: row => <div className="Research-wrap">{row.local_unit_name}</div>,
        sortable: true,
      },
      {
        name: '網站名稱',
        cell: row => {
          const BuildingDateText = formatDate(row.build_date);
          let opcallityText;
          if (row.opcallity === '1') {
            opcallityText = '普';
          } else if (row.opcallity === '2') {
            opcallityText = '中';
          } else if (row.opcallity === '3') {
            opcallityText = '高';
          } else {
            opcallityText = '其他';
          }

          return (
            <div>
              <a href={row.url_addr}>{row.url_name}</a>
              <br />
              {BuildingDateText}
              <br />
              {opcallityText}
            </div>
          );
        },
      },
      {
        name: '狀態',
        selector: row => row.scan_status,
        cell: row => {
          if (row.scan_status === '2') return '掃描成功';
          if (row.scan_status === '1') return '掃描中';
          if (row.scan_status === '3') return `掃描失敗 ${row.note}`;
          if (row.scan_status === '0') return '排程中';
          return '未知';
        },
        sortable: true,
      },
      {
        name: '掃描時間',
        selector: row => row.net_scan_time,
        sortable: false,
      },
      {
        name: '掃描頁數',
        selector: row => row.scanned_page_count,
        sortable: false,
      },
      {
        name: <RiskHeader title="重風險" color="purple" />,
        selector: row => row.heavy,
      },
      {
        name: <RiskHeader title="高風險" color="red" />,
        selector: row => row.high,
      },
      {
        name: <RiskHeader title="中風險" color="orange" />,
        selector: row => row.meddle,
      },
      {
        name: <RiskHeader title="低風險" color="blue" />,
        selector: row => row.low,
      },
      {
        name: <RiskHeader title="訊息" color="green" />,
        selector: row => row.message,
      },
      {
        name: '建立人員',
        selector: row => row.build_id,
        sortable: false,
      },
    ];

    if (this.state.fetchedData.current_user_type === 'S') {
      columns.splice(1, 0, {
        name: '區網',
        selector: row => row.local_net_name,
        cell: row => <div className="Research-wrap">{row.local_net_name}</div>,
        sortable: true,
      });
    }
    return (
      <div>
        <div>
          <Row>
            <Col className="riskSummaryBox"><strong>總共網站數量: {totalSites}</strong></Col>
            <Col className="riskSummaryBox"><strong>重風險網站數量: {heavyRiskSites}</strong></Col>
            <Col className="riskSummaryBox"><strong>高風險網站數量: {highRiskSites}</strong></Col>
            <Col className="riskSummaryBox"><strong>中風險網站數量: {mediumRiskSites}</strong></Col>
            <Col className="riskSummaryBox"><strong>低風險網站數量: {lowRiskSites}</strong></Col>
            <Col className="riskSummaryBox"><strong>訊息風險網站數量: {messageRiskSites}</strong></Col>
          </Row>
        </div>
        <div >
          <DataTable
            columns={columns}
            data={this.state.forecasts}
            pagination
            paginationPerPage={20}
            paginationRowsPerPageOptions={[20, 30, 40, 50, this.state.forecasts.length]}
            tableStyle={{ minWidth: '50rem' }}
            subHeader
            subHeaderComponent={
              <div className="row justify-content-end">
                <div className="col-md-4 input-group">
                  <div className="input-group-prepend bg-info">
                    <span className="input-group-text bg-info" style={{ borderTopLeftRadius: '0.7rem', borderBottomLeftRadius: '0.7rem' }}>
                      <FontAwesomeIcon icon={faSearch} color="white" />
                    </span>
                  </div>
                  <Input
                    type="text"
                    placeholder="篩選-請輸入文字..."
                    value={this.state.filterText}
                    onChange={this.handleFilterChange}
                    className="form-control"
                  />
                </div>
              </div>
            }
            customStyles={{
              headRow: {
                style: { background: 'transparent' },
              },
              headCells: {
                style: { fontSize: '14px', fontWeight: 'bold' },
              },
            }}
            customFilterText={this.state.filterText}
            onFilter={(e) => this.customFilter(e)}
          />
        </div>
        {this.state.fileLoading && (
          <div className="modal-backdrop d-flex justify-content-center align-items-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">載入中...</span>
            </div>
          </div>
        )}
      </div>
    );
  }


  async populateWeatherData() {
    const formData = new FormData();
    const { current_user_type, local_net_id, local_unit_id, url_addr, startDate, endDate } = this.state;

    formData.append("current_user_type", current_user_type);
    formData.append("starttime", startDate);
    formData.append("endtime", endDate);

    switch (current_user_type) {
      case "S":
        formData.append("local_net_id", this.props.fetchedData.selectnet || "");
        formData.append("local_unit_id", this.props.fetchedData.selectedUnitproxy || "");
        formData.append("local_unit_name", this.props.fetchedData.local_unit_proxy_name);
        break;
      case "M":
        formData.append("local_net_id", local_net_id);
        formData.append("local_unit_id", this.props.fetchedData.selectedUnitproxy || "");
        break;
      case "N":
        formData.append("local_unit_id", local_unit_id);
        formData.append("local_net_id", local_net_id);
        break;
      default:
        break;
    }

    formData.append("url_addr", url_addr);
    formData.append("betaversion", this.props.fetchedData.betaversion);

    try {
      const response = await fetch(this.state.apiUrl, {
        method: "POST",
        headers: { "Authorization": localStorage.getItem('accessToken') },
        body: formData
      });
      const data = await response.json();
      const rows = Array.isArray(data.row) ? data.row : [data.row];
      const urlCountMap = new Map();

      rows.forEach(row => {
        const count = urlCountMap.get(row.url_addr) || 0;
        urlCountMap.set(row.url_addr, count + 1);
      });

      const betaversion = this.props.fetchedData.betaversion;
      const betaversionFilteredRows = rows.filter(row => {
        if (betaversion === "0") {
          return true; // 如果 betaversion 是 "0"，則不進行過濾
        }
        return parseInt(row.betaversion, 10) === parseInt(betaversion, 10);
      });
      const latestFilteredRows = betaversionFilteredRows.filter(row => row.historyNumber === "1");

      let totalSites = latestFilteredRows.length;
      let heavyRiskSites = latestFilteredRows.filter(row => row.heavy > 0).length;
      let highRiskSites = latestFilteredRows.filter(row => row.heavy === 0 && row.high > 0).length;
      let mediumRiskSites = latestFilteredRows.filter(row => row.heavy === 0 && row.high === 0 && row.meddle > 0).length;
      let lowRiskSites = latestFilteredRows.filter(row => row.heavy === 0 && row.high === 0 && row.meddle === 0 && row.low > 0).length;
      let messageRiskSites = latestFilteredRows.filter(row => row.heavy === 0 && row.high === 0 && row.meddle === 0 && row.low === 0 && row.message > 0).length;

      this.setState({
        allForecasts: rows, // 所有資料
        forecasts: latestFilteredRows, // 只有 historyNumber === "1" 且符合 betaversion 條件的資料
        totalSites,
        heavyRiskSites,
        highRiskSites,
        mediumRiskSites,
        lowRiskSites,
        messageRiskSites,
        tableLoading: false,
        urlMap: urlCountMap, // 包含所有 url_addr 的計數
        originalForecasts: rows,
      });
    } catch (error) {
      console.error('Error fetching JSON:', error);
    }
  }


}  